import styled from 'styled-components';

import Card from 'components/common/Card';

interface IProps {
  isClickable?: boolean;
  onClick?: () => void;
}

export const ProfileAttendEventPostWrapper = styled(Card)`
  margin: 0 0 16px;
  max-width: 550px;
  width: 100%;
`;

export const MediaWrapper = styled.div<IProps>`
  cursor: ${({ isClickable }) => (isClickable ? 'pointer' : 'auto')};

  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;

  & > span {
    & > img {
      object-fit: cover;
    }
  }
`;

export const CoverImg = styled.div`
  width: 100%;
  height: auto;
`;

export const WheelMarkIconWrap = styled.div`
  width: 100%;

  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 55%,
    rgba(28, 31, 41, 0.2) 100%
  );
  background-color: ${(props) => props.theme.colors.neutral.n4};

  & img {
    background: none;
  }
`;

export const SocialActivityBlock = styled.div``;
